export default __webpack_public_path__ + "static/media/img-BecomeAMember-1d62888b4b662af9142e3c385f423f32.73c32b70.jpg";